/* ===========================
IMPORTS
=========================== */
import React from 'react';
import PropTypes from 'prop-types';
// IMPORT - ELEMENTS
import Loader from '../Elements/Loader';
// IMPORT - Helpers
import Helpers from '../../Helpers';

/* ===========================
CLASS
=========================== */
class ModalDelete extends React.Component {
  /* ===========================
  DEFAULT
  =========================== */
  /**
  * Main constructor of Component
  */
  constructor(props) {
    super(props);

    this.state = {
      errors: null,
    };

    this.handleChange = this.handleChange.bind(this);
  }

  /**
  * componentDidMount
  */
  componentDidMount() {
    this.props.updateLoadingModal(false);
  }

  /* ===========================
  FUNCTIONS
  =========================== */
  /**
   * @param {Event} event
   */
  static handleSubmit(event) {
    this.props.handleSubmit(true);
    Helpers.httpRequest(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_VERSION}/apks/${this.props.data.id}`,
      'delete',
      null,
      // callback
      () => {
        this.props.handleSubmitSuccess();
      },
      // failback
      (error) => {
        this.setState({
          errors: error,
        }, () => {
          this.props.handleSubmit(false);
        });
      },
    );

    event.preventDefault();
  }

  /**
   * @param {Event} event
   */
  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  /* ===========================
  RENDER
  =========================== */
  render() {
    return (
      <div>
        {(!this.props.loading)
          ? (
            <form id={this.props.id} onSubmit={this.handleSubmit}>
              {(this.state.errors && Object.keys(this.state.errors).length > 0)
                ? (
                  <div className="form-group">
                    <div className="alert alert-danger">
                      <ul>
                        {(Object.keys(this.state.errors).map((item) => (
                          <li key={item}>
                            <strong>{item}</strong>
                            {' '}
                            -
                            {' '}
                            {this.state.errors[item]}
                          </li>
                        )))}
                      </ul>
                    </div>
                  </div>
                )
                : ''}

              {(this.props.submitted)
                ? (<Loader />)
                : ''}
            </form>
          )
          : ''}
      </div>
    );
  }
}

/* ===========================
PROPERTY TYPES
=========================== */
ModalDelete.propTypes = {
  updateLoadingModal: PropTypes.func,
  handleSubmit: PropTypes.func,
  data: PropTypes.object,
  handleSubmitSuccess: PropTypes.func,
  loading: PropTypes.bool,
  submitted: PropTypes.bool,
  id: PropTypes.string,
};

/* ===========================
EXPORT
=========================== */
export default ModalDelete;
